import { useEffect, useState } from "react";
import { Share2, Link2, Check, Instagram, MessageCircle } from "lucide-react";

const TEXT = "Deoria Taal Trek · 21-25 Nov 2026 · Travel with Advaita. Chaos se door... pure mountain mode ON!";
// Backend preview link: serves Open Graph tags to WhatsApp/Instagram scrapers, redirects people to /deoria-taal.
const SHARE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/share/deoria-taal`;

export const ShareTrip = ({ compact = false }) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const url = SHARE_URL;

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!e.target.closest("[data-testid='deoria-share']")) setOpen(false); };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch {
      window.prompt("Copy this link", url);
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "Deoria Taal Trek", text: TEXT, url }); return; } catch { /* user dismissed */ }
    }
    setOpen((o) => !o);
  };

  const instagram = async () => {
    await copy();
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`dt-share ${compact ? "is-compact" : ""}`} data-testid="deoria-share">
      <button type="button" className="dt-share-btn" onClick={nativeShare} data-testid="deoria-share-button" aria-expanded={open}>
        <Share2 size={16} /> Share
      </button>
      <div className={`dt-share-menu ${open ? "is-open" : ""}`} data-testid="deoria-share-menu">
        <a href={`https://wa.me/?text=${encodeURIComponent(`${TEXT}\n${url}`)}`} target="_blank" rel="noopener noreferrer" data-testid="deoria-share-whatsapp"><MessageCircle size={16} /> WhatsApp</a>
        <button type="button" onClick={instagram} data-testid="deoria-share-instagram"><Instagram size={16} /> Instagram <small>copies link</small></button>
        <button type="button" onClick={copy} data-testid="deoria-share-copy">{copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? "Link copied" : "Copy link"}</button>
      </div>
    </div>
  );
};
